import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import {
  ADD_SMS_TEMPLATE,
  EDIT_SMS_TEMPLATE,
  GET_SMS_TEMPLATE,
} from "./actionTypes";
import {
  addSMSTemplate,
  editSMSTemplate,
  getSMSTemplate,
} from "../../http/UAM/sms.helper";
import { allSMSTemplate } from "./action";
import { decryptedValue } from "common/utility";

const encryptedtemplate = btoa("sms");

function* addSMSTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(addSMSTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getSMSTemplates({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getSMSTemplate, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allSMSTemplate({ data }));
    } else {
      yield put(allSMSTemplate({ data: [] }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editSMSTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(editSMSTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* SMStemplateSaga() {
  yield takeLatest(ADD_SMS_TEMPLATE, addSMSTemplates);
  yield takeLatest(GET_SMS_TEMPLATE, getSMSTemplates);
  yield takeLatest(EDIT_SMS_TEMPLATE, editSMSTemplates);
}

export default SMStemplateSaga;
